import React, { useState, useEffect } from "react";
import axios from "../helper/axios";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import FormatPrice from "../helper/FormatPrice";

const ListSection = ({ title, items, showAll, handleClick, selectedItem }) => {
  const renderedItems = showAll ? items : items.slice(0, 3);

  return (
    <div className="col-sm-4 col-6 mb-4">
      <h6 className="pb-lg-2 pb-sm-3">
        <b>{title}</b>
      </h6>
      <ul className="p-0 m-0 shop-list-group">
        {renderedItems.map((item, index) => (
          <li
            className={`list-group-item ${
              selectedItem === item ? "font-weight-bold" : ""
            }`}
            key={index}
          >
            <span onClick={() => handleClick(item, false)}>{item}</span>{" "}
          </li>
        ))}
      </ul>
      <a
        className="text-link mt-3 view-all"
        onClick={() => handleClick(null, true)}
      >
        {showAll ? "Show Less" : "View All"}
      </a>
    </div>
  );
};

const Engagement = () => {
  const [showAllProductSettingItems, setShowAllProductSettingItems] =
    useState(false);
  const [showAllMetalItems, setShowAllMetalItems] = useState(false);
  const [showAllStyleItems, setShowAllStyleItems] = useState(false);

  const [getMetal, setMetal] = useState([]);
  const [getProductSetting, setProductSetting] = useState([]);
  const [getStyle, setStyle] = useState([]);

  const [allMetalResponse, setAllMetalResponse] = useState([]);

  const defaultMetalValue = "white gold";
  const defaultSettingValue = "classic prong";
  const defaultStyleValue = "Solitaire";

  const [selectedMetalItems, setSelectedMetalItems] = useState([
    defaultMetalValue,
  ]);
  const [selectedProductSetting, setSelectedProductSetting] = useState([
    defaultSettingValue,
  ]);
  const [selectedStyles, setSelectedStyles] = useState([defaultStyleValue]);
  const [viewAllClicked, setViewAllClicked] = useState(true);

  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);

  const [minCarat, setMinCarat] = useState(0.01);
  const [maxCarat, setMaxCarat] = useState(0.01);

  const [allProducts, getAllProducts] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [sortOption, setSortOption] = useState("");

  const [filteredProduct, setFilteredProduct] = useState([]);

  useEffect(() => {
    fetchJeweleryData();
    handleViewAllClick();
  }, []);

  useEffect(() => {
    filterAndSortProducts();
  }, [
    filteredData,
    allProducts,
    minCarat,
    maxCarat,
    minPrice,
    maxPrice,
    sortOption,
  ]);

  // Saving the filter values to localStorage whenever they change
  useEffect(() => {
    const filterValues = {
      minPrice,
      maxPrice,
      minCarat,
      maxCarat,
      sortOption,
    };
    localStorage.setItem("filterValues", JSON.stringify(filterValues));
  }, [minPrice, maxPrice, minCarat, maxCarat, sortOption]);

  // Loading the filter values from localStorage when the component mounts
  useEffect(() => {
    const storedFilterValues = localStorage.getItem("filterValues");
    if (storedFilterValues) {
      const filterValues = JSON.parse(storedFilterValues);
      setMinCarat(filterValues.minCarat);
      setMaxCarat(filterValues.maxCarat);
      setMinPrice(filterValues.minPrice);
      setMaxPrice(filterValues.maxPrice);
      setSortOption(filterValues.sortOption);
    }
  }, []);

  const handlePriceRangeChange = (value) => {
    setMinPrice(value[0]);
    setMaxPrice(value[1]);
  };

  const handleCaratRangeChange = (value) => {
    setMinCarat(value[0]);
    setMaxCarat(value[1]);
  };

  const filterAndSortProducts = () => {
    let filteredProducts = [...filteredData];

    filteredProducts = filterProductsByPrice(
      minPrice,
      maxPrice,
      filteredProducts
    );
    filteredProducts = filterProductsByCarat(
      minCarat,
      maxCarat,
      filteredProducts
    );

    if (sortOption === "priceHighToLow") {
      filteredProducts.sort((a, b) => b.product_price - a.product_price);
    } else if (sortOption === "priceLowToHigh") {
      filteredProducts.sort((a, b) => a.product_price - b.product_price);
    } else if (sortOption === "nameAZ") {
      filteredProducts.sort((a, b) =>
        a.product_name.localeCompare(b.product_name)
      );
    } else if (sortOption === "new") {
      filteredProducts.sort(
        (a, b) =>
          new Date(b.product_created_on) - new Date(a.product_created_on)
      );
    }

    setFilteredProduct(filteredProducts);
  };

  const filterProductsByPrice = (minPrice, maxPrice, products) => {
    return products.filter(
      (product) =>
        product.product_price >= minPrice && product.product_price <= maxPrice
    );
  };

  const filterProductsByCarat = (minCarat, maxCarat, products) => {
    return products.filter(
      (product) => product.carat >= minCarat && product.carat <= maxCarat
    );
  };

  const fetchJeweleryData = async () => {
    try {
      const category = {
        category: ["jewelry"],
        collection: ["engagement"],
        isAll: 1,
      };
      const response = await axios.post("/product_read", category);
      const allProducts = response.data.data;
      getAllProducts(allProducts);

      const metalData = await axios.get("/metal_read");
      const metalProduct = metalData.data.data;
      setAllMetalResponse(metalProduct);
      const metalArray = Object.values(metalProduct).map(
        (metal) => metal.metal_name
      );
      setMetal(metalArray.slice(0, -1));

      const productSettingsData = await axios.get("/product_settings_read");
      const productSettingsProduct = productSettingsData.data.data;
      const productSettingsArray = Object.values(productSettingsProduct).map(
        (productsettings) => productsettings.product_settings_name
      );
      setProductSetting(productSettingsArray.slice(0, -1));

      const StyleData = await axios.get("/style_read");
      const StyleProduct = StyleData.data.data;
      const styleArray = Object.values(StyleProduct).map(
        (styleProduct) => styleProduct.style_name
      );
      setStyle(styleArray.slice(0, -1));
    } catch (error) {
      console.error(error.response);
      console.log("alert̥: Failed to fetch products.");
    }
  };

  const handleClickProductSetting = (item, isViewAll) => {
    if (isViewAll) {
      setShowAllProductSettingItems(!showAllProductSettingItems);
      setSelectedProductSetting(item ? [item] : []);
    } else {
      setSelectedProductSetting((prevSelected) => {
        if (prevSelected.includes(item)) {
          return prevSelected.filter((selectedItem) => selectedItem !== item);
        } else {
          return [item];
        }
      });
    }
  };

  const handleClickMetal = (item, isViewAll) => {
    if (isViewAll) {
      setShowAllMetalItems(!showAllMetalItems);
      setSelectedMetalItems(item ? [item] : []);
    } else {
      setSelectedMetalItems((prevSelected) => {
        if (prevSelected.includes(item)) {
          return prevSelected.filter((selectedItem) => selectedItem !== item);
        } else {
          return [item];
        }
      });
    }
  };

  const handleClickStyle = (item, isViewAll) => {
    if (isViewAll) {
      setShowAllStyleItems(!showAllStyleItems);
      setSelectedStyles(item ? [item] : []);
    } else {
      setSelectedStyles((prevSelected) => {
        if (prevSelected.includes(item)) {
          return prevSelected.filter((selectedItem) => selectedItem !== item);
        } else {
          return [item];
        }
      });
    }
  };

  const handleViewAllClick = async () => {
    if (
      selectedMetalItems.length > 0 ||
      selectedProductSetting.length > 0 ||
      selectedStyles.length > 0
    ) {
      const filteredProductData = {
        category: ["jewelry"],
        collection: ["Engagement"],
        metal: selectedMetalItems,
        settings: selectedProductSetting,
        product_style: selectedStyles,
        isAll: 1,
        // from_price: minPrice,
        // to_price: maxPrice,
        // min_carat: ,
        // max_carat:
      };

      try {
        const response = await axios.post("/product_read", filteredProductData);
        const newData = response.data.data;
        console.log("̥newData", newData);
        setFilteredData(newData);
        console.log("̥filteredProductData", filteredProductData);
        console.log("̥response", response);
        setViewAllClicked(true);
      } catch (error) {
        console.error("Error sending data:", error);
        alert("No data Found!!");
      }
    }
  };

  const navigate = useNavigate();

  const handleProductClick = async (product) => {
    const payload = {
      product_sku: product.product_sku,
    };
    try {
      const response = await axios.post("/product_read", payload);
      const singleProductData = response.data.data;
      navigate(`/singleproduct/${singleProductData[0].product_sku}`);
    } catch (error) {
      console.error("Error fetching single product:", error);
    }
  };

  const metalElements = allMetalResponse.map((metalItem, index) => (
    <option key={index} value={metalItem.metal_id}>
      {metalItem.metal_name}
    </option>
  ));

  const allPrices = filteredData.map((product) => product.product_price);
  const initialMinPrice = Math.min(...allPrices);
  const initialMaxPrice = Math.max(...allPrices);

  const allCarat = filteredData.map((product) => product.carat);
  const initialMinCarat = parseFloat(Math.min(...allCarat));
  const initialMaxCarat = parseFloat(Math.max(...allCarat));

  useEffect(() => {
    setMinPrice(initialMinPrice);
    setMaxPrice(initialMaxPrice);

    setMinCarat(initialMinCarat);
    setMaxCarat(initialMaxCarat);
  }, [initialMinPrice, initialMaxPrice, initialMinCarat, initialMaxCarat]);

  const resetSlider = () => {
    setMinPrice(initialMinPrice);
    setMaxPrice(initialMaxPrice);
    setMinCarat(initialMinCarat);
    setMaxCarat(initialMaxCarat);
    // setViewAllClicked(true);
    setSortOption("select");
  };

  const handleSortChange = (event) => {
    const selectedOption = event.target.value;
    setSortOption(selectedOption);
  };

  useEffect(() => {
    // Reset the sort option when the price range changes
    setSortOption("select");
  }, [minPrice, maxPrice, minCarat, maxCarat]);

  return (
    <>
      <section>
        {/* <div className="container-fluid">
          <div className="row">
            <div className="page-banner hero-container mb-0">
              <div className="banner-content">
                <h1>Engagement</h1>
              </div>
            </div>
          </div>
        </div> */}

        <div className="container">
          <div className="row pt-5">
            <div className="col-md-6">
              <div className="row">
                <div className="col-12">
                  <h4 className="pb-4">
                    <b>Pre-Designed Engagement Ring</b>
                  </h4>
                </div>
              </div>
              <div className="row">
                <ListSection
                  title="Shop by Metal"
                  items={getMetal}
                  showAll={showAllMetalItems}
                  handleClick={handleClickMetal}
                  selectedItem={selectedMetalItems[0]}
                />

                <ListSection
                  title="Shop by Settings"
                  items={getProductSetting}
                  showAll={showAllProductSettingItems}
                  handleClick={handleClickProductSetting}
                  selectedItem={selectedProductSetting[0]}
                />

                <ListSection
                  title="Shop by Style"
                  items={getStyle}
                  showAll={showAllStyleItems}
                  handleClick={handleClickStyle}
                  selectedItem={selectedStyles[0]}
                />
              </div>

              <div className="row">
                <button
                  onClick={handleViewAllClick}
                  disabled={selectedMetalItems.length === 0}
                  className="btn btn__outline"
                >
                  View All
                </button>
              </div>
            </div>
            <div className="col-md-6 ps-sm-5 pt-lg-0 pt-md-5">
              <div className="design-own-ring text-center">
                <h4 className="pb-5 text-center">
                  <b>Design Your Engagement Ring</b>
                </h4>
                <div>
                  <ul className="progressbar">
                    <li className="active">Select Your Diamond</li>
                    <li>Select Setting</li>
                    <li>Buy a Ring</li>
                  </ul>
                </div>

                <a
                  href="/allproducts"
                  className="btn btn__primary mb-4 mt-4 mx-auto d-inline-block w-auto"
                >
                  Try Now
                </a>
              </div>
            </div>
          </div>

          <div className="row text-center mt-5 pt-5">
            <div className="col-12">
              <h3 className="mb-4">
                <b>Check Our All Pre-Designed Engagement Rings</b>
              </h3>

              <div className="filter-menu-section d-flex align-items-center w-100">
                <div className="filter-menu-block">
                  <h5 className="filter-menu-heading">
                    Filter by Price <i className="fa-solid fa-angle-down"></i>
                  </h5>
                  <div className="filter-menu-option">
                    <Slider
                      range
                      allowCross={false}
                      value={[minPrice, maxPrice]}
                      onChange={handlePriceRangeChange}
                      min={initialMinPrice}
                      max={initialMaxPrice}
                      step={1}
                      id="price"
                      name="price"
                      list="price"
                    />
                    <div className="row">
                      <div className="form-group col-6">
                        <label className="pb-2" htmlFor="minPrice">
                          Min Price
                        </label>
                        <input
                          type="number"
                          id="minPrice"
                          name="minPrice"
                          value={minPrice}
                          onChange={(e) =>
                            setMinPrice(parseFloat(e.target.value))
                          }
                          step={1000}
                          min={initialMinPrice}
                          max={initialMaxPrice}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group col-6">
                        <label className="pb-2" htmlFor="maxPrice">
                          Max Price
                        </label>
                        <input
                          type="number"
                          id="maxPrice"
                          name="maxPrice"
                          value={maxPrice}
                          onChange={(e) =>
                            setMaxPrice(parseFloat(e.target.value))
                          }
                          step={1000}
                          min={initialMinPrice}
                          max={initialMaxPrice}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-menu-block">
                  <h5 className="filter-menu-heading">
                    Filter by Carat <i className="fa-solid fa-angle-down"></i>
                  </h5>
                  <div className="filter-menu-option">
                    <Slider
                      range
                      allowCross={false}
                      value={[minCarat, maxCarat]}
                      onChange={handleCaratRangeChange}
                      min={initialMinCarat}
                      max={initialMaxCarat}
                      step={0.01}
                      id="carat"
                      name="carat"
                      list="carat"
                    />
                    <div className="row">
                      <div className="form-group col-6">
                        <label className="pb-2" htmlFor="minCarat">
                          Min Carat
                        </label>
                        <input
                          type="number"
                          id="minCarat"
                          name="minCarat"
                          value={minCarat}
                          onChange={(e) =>
                            setMinCarat(parseFloat(e.target.value))
                          }
                          step={0.01}
                          min={initialMinCarat}
                          max={initialMaxCarat}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group col-6">
                        <label className="pb-2" htmlFor="maxCarat">
                          Max Carat
                        </label>
                        <input
                          type="number"
                          id="maxCarat"
                          name="maxCarat"
                          value={maxCarat}
                          onChange={(e) =>
                            setMaxCarat(parseFloat(e.target.value))
                          }
                          step={0.01}
                          min={initialMinCarat}
                          max={initialMaxCarat}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-menu-block">
                  <select
                    id="sortOption"
                    name="sortOption"
                    value={sortOption}
                    onChange={handleSortChange}
                    className="form-select border-0 outline-0"
                  >
                    <option value="best">Best Sellers</option>
                    <option value="top">Top Rated</option>
                    <option value="new">Newest</option>
                    <option value="priceHighToLow">Price High to Low</option>
                    <option value="priceLowToHigh">Price Low to High</option>
                    <option value="nameAZ">Name A to Z</option>
                  </select>
                </div>
                <div className="filter-menu-block text-end ms-auto p-0">
                  <div className="price-slider-label text-end">
                    {/* <span>Min Price: {minPrice}, </span>
                  <span>Max Price: {maxPrice}</span> */}
                    <button
                      className="btn m-0 btn__primary"
                      onClick={resetSlider}
                    >
                      <b>Reset Filters</b>
                    </button>
                  </div>
                </div>
              </div>

              <div className="row mt-5">
                {filteredProduct.map((product, index) => (
                  <NavLink
                    onClick={() => handleProductClick(product)}
                    className="col-sm-3 mb-4 card"
                    key={index}
                  >
                    <div className="product-card card-body">
                      <div className="p-0">
                        <img
                          src={product.product_image[0]}
                          className="w-100"
                          // onMouseOver={}
                        />
                        <h5 className="mt-3 card-title">
                          {product.product_name}
                        </h5>
                        <span className="d-block">
                          Price: <FormatPrice price={product.product_price} />
                        </span>
                      </div>
                    </div>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-5">
              <h3 className="text-center">
                <b>Unveiling Timeless Glamour</b>
              </h3>
            </div>
            <div className="col-sm-6 mb-0">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-4.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Silver Moon</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mb-0">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-1.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Divine Heritage</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-2.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Colorful Gems</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="collection-block mb-4">
                <img
                  src={require("../assets/collection-ring-3.jpg")}
                  className="w-100"
                  alt=""
                />
                <div className="collection-details">
                  <h4>Celestial Beauty</h4>
                  <button className="btn__outline">Buy Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Engagement;
